import React from 'react';
import './ServicePage.css';

const NotFound = () => (
  <div className="service-page" style={{minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    <h1 style={{ fontSize: 48, color: '#0d5097', fontWeight: 700 }}>404</h1>
    <h2 style={{ color: '#222', fontWeight: 600 }}>Page Not Found</h2>
    <p style={{ color: '#666', fontSize: 18, maxWidth: 400, textAlign: 'center' }}>
      The page you're looking for doesn't exist or has been moved.
    </p>
  </div>
);

export default NotFound;
